import { ISite } from 'shared/api/api';

export const LOAD = 'LOAD';
export const SAVE_SITE = 'SAVE_SITE';
export const CREATE_SITE = 'CREATE_SITE';
export const GET_ALL_SITES = 'GET_ALL_SITES';
export const MIGRATION_DOWNSTREAM = 'MIGRATION_DOWNSTREAM';
export const MIGRATION_TO_ARCHIVE = 'MIGRATION_TO_ARCHIVE';
export const MIGRATION_FROM_ARCHIVE = 'MIGRATION_FROM_ARCHIVE';
export const GET_ARCHIVED_SITES = 'GET_ARCHIVED_SITES';

export interface SiteState {
	site: ISite;
	isLoading?: boolean;
    sites: ISite[];
    archivedSites: ISite[];
}
